// Loqate's address lookup assigns straight to element.value and fires no DOM event of any kind
// (verified in platformcaptureplus-2.10.min.js: setValue only assigns, and the address populate
// loop raises the library's own "populate", not an input or a change). Vue's v-model listens for
// input, so a looked-up address never reaches the reactive state behind the field, and the next
// re-render writes the stale model value back over what the customer can see.
//
// Replaying an input event per field on populate lets v-model's own handler read element.value
// and catch up, which keeps the reactive object the single source of truth.

/**
 * Bridge Loqate's field writes into Vue's v-model.
 *
 * THE TRAP: Loqate's dispatcher calls only the LAST callback registered for an event
 * (pca.platform.fire reads onq[i][onq[i].length - 1]), and nothing ever replaces the queueing
 * pca.on stub in master.blade.php. So this must be the only 'load' binding on the site -
 * anything else needing one belongs inside this callback, or one of the two silently dies.
 */
export function syncLoqateWithVue() {
    // master.blade.php defines pca.on ahead of sensor.js and queues the call, so registering
    // before Loqate has loaded is safe. The guard is for Loqate being blocked entirely.
    if (! window.pca?.on) return;

    window.pca.on('load', (type, key, control) => {
        if (type !== 'capture+') return;

        control.listen('populate', () => {
            control.fields?.forEach(({ element }) => {
                // Loqate accepts an id or a node for a bound field, and hands back whichever
                // it was given.
                const field = typeof element === 'string' ? document.getElementById(element) : element;

                field?.dispatchEvent(new Event('input', { bubbles: true }));
            });
        });
    });
}
